import { render, staticRenderFns } from "./AssessmentExamPills.vue?vue&type=template&id=ec2a3bf4&"
import script from "./AssessmentExamPills.vue?vue&type=script&lang=js&"
export * from "./AssessmentExamPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports